// extracted by mini-css-extract-plugin
export default {"mainLayout":"mainLayout_mainLayout__iC55s","MainBody":"mainLayout_MainBody__mkDSI","outlet-wrapper":"mainLayout_outlet-wrapper__oHWMe"};